// 云直播
const liveIndex = resolve => require(['@/views/live/index.vue'], resolve);
const channellist = resolve => require(['@/views/live/channel/channellist.vue'], resolve);
const srtchannellist = resolve => require(['@/views/live/srtchannel/channellist.vue'], resolve);
const srtpulllist = resolve => require(['@/views/live/srtchannel/pulldetail.vue'], resolve);
const srtchannelMonitor = resolve => require(['@/views/live/srtchannel/channelMonitor.vue'], resolve);
const channelbuilt = resolve => require(['@/views/live/channel/channelbuilt.vue'], resolve);
const signalList = resolve => require(['@/views/live/signal/signalList.vue'], resolve);
const signalConfig = resolve => require(['@/views/live/signal/signalConfig.vue'], resolve);
const distributionList = resolve => require(['@/views/live/distribution/distributionList.vue'], resolve);
const srtchannelbuilt = resolve => require(['@/views/live/srtchannel/channelbuilt.vue'], resolve);
const channelrotate = resolve => require(['@/views/live/channel/channelrotate.vue'], resolve);
const ChannelMonitor = resolve => require(['@/views/live/channel/ChannelMonitor.vue'], resolve);
const broadcastlist = resolve => require(['@/views/live/broadcast/broadcastlist.vue'], resolve);
const broadcastBigScreen = resolve => require(['@/views/live/broadcast/bigScreen.vue'], resolve);
const broadcastoperation = resolve => require(['@/views/live/broadcast/broadcastoperation.vue'], resolve);
const broadcastbuilt = resolve => require(['@/views/live/broadcast/broadcastbuilt.vue'], resolve);
const specialbuilt = resolve => require(['@/views/live/broadcast/specialbuilt.vue'], resolve);
const recordtasklist = resolve => require(['@/views/live/recordtask/recordtasklist.vue'], resolve);
const watermarklist = resolve => require(['@/views/live/watermark/watermarklist.vue'], resolve);
const connectionList = resolve => require(['@/views/live/connection/connectionList.vue'], resolve);
const connectionMonitor = resolve => require(['@/views/live/connection/connectionMonitor.vue'], resolve);
const flowmonitorList = resolve => require(['@/views/live/flowmonitor/flowmonitorList.vue'], resolve);
const flowmonitorEdit = resolve => require(['@/views/live/flowmonitor/flowmonitorEdit.vue'], resolve);
const flowmonitorBigScreen = resolve => require(['@/views/live/flowmonitor/bigScreen.vue'], resolve);

//直播菜单
let liveMenu = {
  meta: {
    auth: true,
    perm: "daguan-live-module-open",

    moduleName: '云直播'
  },
  path: '/live', // 跳转云直播页面
  component: liveIndex,
  children: [{
      meta: {
        auth: true,
        perm: "daguan-live-channel-query",

        moduleName: '通道管理'
      },
      path: '/live', // 默认跳转概况查询页面
      redirect: '/live/channel/list'
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-channel-query",

        moduleName: '通道管理'
      },
      path: '/live/channel/list', // 跳转通道管理页面
      component: channellist
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-channel-edit",

        moduleName: '通道编辑'
      },
      path: '/live/channel/built/:cid', // 跳转新建通道页面
      component: channelbuilt
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-channel-query",
        moduleName: '信号调度'
      },
      path: '/live/signal/list', // 跳转通道管理页面
      component: signalList
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-channel-query",
        moduleName: '信号调度'
      },
      path: '/live/signal/config/:taskId', // 跳转通道管理页面
      component: signalConfig
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-channel-query",
        moduleName: '分发平台'
      },
      path: '/live/distribution/list', // 跳转通道管理页面
      component: distributionList
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-channel-topush",

        moduleName: '转推'
      },
      path: '/live/channel/rotate/:cid', // 跳转转推第三方页面
      component: channelrotate
    },
    {
      meta: {
        auth: true,
        perm: "",
        moduleName: '监控'
      },
      // name: 'liveChannelMonitor',
      path: '/live/channel/monitor/:cid/:streamName/:showFirst', // 跳转转推第三方页面
      component: ChannelMonitor
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-activity-query",

        moduleName: '直播活动'
      },
      path: '/live/broadcast/list/:type', // 跳转直播活动页面
      component: broadcastlist
    },
    {
      path: '/live/broadcast/bigScreen/:activityId/:themeType', // 跳转直播大屏页面
      component: broadcastBigScreen
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-activity-operation",

        moduleName: '直播运营'
      },
      path: '/live/broadcast/operation/:activityId/:type', // 跳转直播运营页面
      component: broadcastoperation
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-activity-edit",

        moduleName: '直播活动编辑'
      },
      path: '/live/broadcast/built/:activityId', // 跳转新建活动页面
      component: broadcastbuilt
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-activity-edit",

        moduleName: '专题活动编辑'
      },
      path: '/live/special/built/:activityId', // 跳转新建专题活动页面
      component: specialbuilt
    },

    {
      meta: {
        auth: true,
        perm: "daguan-live-record-query",
        moduleName: '录制任务'
      },
      path: '/live/recordtask/list', // 跳转录制任务页面
      component: recordtasklist
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-watermark-query",
        moduleName: '直播水印'
      },
      path: '/live/watermark/list', // 跳转直播水印页面
      component: watermarklist
    },
    {
      meta: {
        auth: true,
        perm: "daguan-connection-module-open",
        moduleName: '直播连线'
      },
      path: '/live/connection/list', // 跳转直播连线列表页面
      component: connectionList
    },
    {
      meta: {
        auth: true,
        perm: "daguan-connection-module-open",
        moduleName: '连线监控'
      },
      path: '/live/connection/monitor', // 跳转直播连线监控页面
      component: connectionMonitor
    },
    {
      path: '/live/flowmonitor/list', // 跳转直播流监控页面
      component: flowmonitorList
    },
    {
      path: '/live/flowmonitor/edit/:fid', // 跳转直播流监控页面
      component: flowmonitorEdit
    },
    {
      path: '/live/flowmonitor/bigScreen/:fid', // 跳转直播流监控大屏页面
      component: flowmonitorBigScreen
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-channel-query",

        moduleName: 'SRT通道管理'
      },
      path: '/live/srtchannel/list', // 跳转通道管理页面
      component: srtchannellist
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-channel-query",

        moduleName: 'SRT通道监控'
      },
      path: '/live/srtchannel/monitor/:streamName', // 跳转通道管理页面
      component: srtchannelMonitor
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-channel-query",

        moduleName: 'SRT拉流管理'
      },
      path: '/live/srtpull/list', // 跳转通道管理页面
      component: srtpulllist
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-channel-query",

        moduleName: 'SRT拉流监控'
      },
      path: '/live/srtpull/monitor/:streamName/:clientId', // 跳转通道管理页面
      component: srtchannelMonitor
    },
    {
      meta: {
        auth: true,
        perm: "daguan-live-channel-edit",

        moduleName: 'SRT通道编辑'
      },
      path: '/live/srtchannel/built/:cid', // 跳转新建通道页面
      component: srtchannelbuilt
    }
  ]
}

// 云点播
const vodIndex = resolve => require(['@/views/vod/index.vue'], resolve);
const uploadList = resolve => require(['@/views/vod/videoUpload/uploadList.vue'], resolve);
const videoManageList = resolve => require(['@/views/vod/videoManage/videoManageList.vue'], resolve);
const videoManageOperation = resolve => require(['@/views/vod/videoManage/videoManageOperation.vue'], resolve);
const compilationManageList = resolve => require(['@/views/vod/compilationManage/compilationManageList'], resolve);
const commentManageList = resolve => require(['@/views/vod/commentManage/commentManageTab'], resolve);
const preferenceSet = resolve => require(['@/views/vod/preference/preferenceSet'], resolve);
const audioManageList = resolve => require(['@/views/vod/audioManage/audioManageList'], resolve);


let vodMemu = {
  meta: {
    auth: true,
    perm: "daguan-vod-module-open",
    moduleName: '云点播'
  },
  path: '/vod', // 跳转云点播页面
  component: vodIndex,
  children: [{
      meta: {
        auth: true,
        perm: 'daguan-vod-video-upload',
        moduleName: '点播上传'
      },
      path: '/vod', // 默认跳转视频上传页面
      redirect: '/vod/videoUpload/list'
    },
    {
      meta: {
        auth: true,
        perm: 'daguan-vod-video-upload',
        moduleName: '点播上传'
      },
      path: '/vod/videoUpload/list', // 跳转视频上传页面
      component: uploadList
    },
    {
      meta: {
        auth: true,
        perm: 'daguan-vod-video-query',
        moduleName: '视频管理'
      },
      path: '/vod/videoManage/list', // 跳转视频管理列表页面
      component: videoManageList
    },
    {
      meta: {
        auth: true,
        perm: 'daguan-vod-video-operation',
        moduleName: '视频运营'
      },
      path: '/vod/videoManage/operation/:mediaId', // 跳转视频管理运营页面
      component: videoManageOperation
    },
    {
      meta: {
        auth: true,
        perm: 'daguan-vod-album-query',
        moduleName: '合辑管理'
      },
      path: '/vod/compilationManage/list', // 跳转合集管理列表页面
      component: compilationManageList
    },
    {
      meta: {
        auth: true,
        perm: 'daguan-vod-comment-open',
        moduleName: '评论管理'
      },
      path: '/vod/commentManage/list', // 跳转评论管理列表页面
      component: commentManageList
    },
    {
      path: '/vod/preference/set/:tab/:thirdParty', // 跳转偏好设置页面
      component: preferenceSet
    },
    {
      meta: {
        auth: true,
        keepAlive: true,
        perm: 'daguan-vod-audio-manage',
        moduleName: '音频管理'
      },
      path: '/vod/audioManage/list', // 跳转音频管理页面
      component: audioManageList
    },
  ]
}

// 云制作
const productionIndex = resolve => require(['@/views/production/index'], resolve);
const directorlist = resolve => require(['@/views/production/director/directorlist'], resolve);
const directorManagementActive = resolve => require(['@/views/production/director/directorManagementActive'], resolve);
const directorPreview = resolve => require(['@/views/production/director/directorPreview'], resolve);
const directorStation = resolve => require(['@/views/production/director/directorStation'], resolve);
const CgManage = resolve => require(['@/views/production/director/cg-material/index'], resolve);
const materiallist = resolve => require(['@/views/production/material/materiallist'], resolve);
const editIndex = resolve => require(['@/views/production/cloudEditing/editIndex'], resolve);
const vodEdit = resolve => require(['@/views/production/cloudEditing/vodEdit'], resolve);
const liveEdit = resolve => require(['@/views/production/cloudEditing/newLiveEdit'], resolve);
const passbackList = resolve => require(['@/views/production/passback/passbackList'], resolve);
const workshopList = resolve => require(['@/views/production/subtitle/workshopList'], resolve);
const workshopEdit = resolve => require(['@/views/production/subtitle/workshopEdit'], resolve);
const gifEditorIndex = resolve => require(['@/views/production/gifEditor'], resolve);
const gifEditorArea = resolve => require(['@/views/production/gifEditor/editorArea'], resolve);
const mosaicIndex = resolve => require(['@/views/production/mosaic/index'], resolve)
const mosaicPreview = resolve => require(['@/views/production/mosaic/mosaicPreview'], resolve)


//云制作菜单
let productionMenu = {
  meta: {
    auth: true,
    perm: "daguan-manufacture-module-open",
    moduleName: '云制作'
  },
  path: '/production', // 跳转云制作
  component: productionIndex,
  children: [{
      meta: {
        auth: true,
        perm: "daguan-manufacture-director-query",
        moduleName: '云导播'
      },
      path: '/production', // 默认跳转云导播
      redirect: '/production/director/list'
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-director-query",
        moduleName: '云导播'
      },
      path: '/production/director/list', // 跳转导播管理页面
      component: directorlist
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-director-edit",
        moduleName: '云导播管理'
      },
      path: '/production/director/manage/:roomId', // 跳转导播控制页面
      component: directorManagementActive
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-director-edit",
        moduleName: '云导播管理'
      },
      path: '/production/director/preview/:channelId/:delay', // 跳转导播预览页面
      component: directorPreview
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-director-edit",
        moduleName: '云导播管理'
      },
      path: '/production/director/station', // 跳转导播台操作页面
      component: directorStation
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-director-edit",
        moduleName: 'CG管理'
      },
      path: '/production/cg/manage', // 跳转导播台操作页面
      component: CgManage
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-material-query",
        moduleName: '素材管理'
      },
      path: '/production/material/list', // 跳转素材管理页面
      component: materiallist
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-editor-open",
        moduleName: '云剪辑'
      },
      path: '/production/cloudEditing/editIndex', // 跳转云剪辑主页面
      component: editIndex
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-editor-open",
        moduleName: '云剪辑'
      },
      path: '/production/cloudEditing/vodEdit/:taskId', // 跳转云点播剪辑页面
      component: vodEdit
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-editor-open",
        moduleName: '云剪辑'
      },
      path: '/production/cloudEditing/liveEdit', // 跳转云直播剪辑页面
      component: liveEdit
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-module-open",
        moduleName: '回传素材'
      },
      path: '/production/passback/list', // 跳转回传素材页面
      component: passbackList
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-workshop-query",
        moduleName: '字幕工坊'
      },
      path: '/production/subtitle/workshopList', // 跳转字幕工坊列表页面
      component: workshopList
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-workshop-query",
        moduleName: '字幕工坊编辑'
      },
      path: '/production/subtitle/workshopEdit/:taskId', // 跳转字幕工坊编辑页面
      component: workshopEdit
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-gif-query",
        moduleName: 'GIF制作'
      },
      path: '/production/gifEditor', // 跳转GIF制作主页面
      component: gifEditorIndex
    },
    {
      meta: {
        auth: true,
        perm: "daguan-manufacture-gif-query",
        moduleName: 'GIF制作'
      },
      path: '/production/gifEditor/editorArea', // 跳转GIF制作主页面
      component: gifEditorArea
    },
    {
      meta: {
        auth: true,
        perm: "",
        moduleName: '多画面拼接'
      },
      path: '/production/mosaic', // 跳转多画面拼接
      component: mosaicIndex
    },
    {
      meta: {
        auth: true,
        perm: "",
        moduleName: '多画面拼接预览'
      },
      path: '/production/mosaic/preview/:rtcId/:ctaskId', // 跳转多画面拼接预览
      component: mosaicPreview
    },
  ]
}


// 视频微站
const microstationIndex = resolve => require(['@/views/microstation/index'], resolve);
const newStation = resolve => require(['@/views/microstation/stations/newStation'], resolve);
const builtStation = resolve => require(['@/views/microstation/stations/builtStation'], resolve);
const publishStation = resolve => require(['@/views/microstation/stations/publishStation'], resolve);
const stationList = resolve => require(['@/views/microstation/stations/stationlist'], resolve);

let microMenu = {
  meta: {
    auth: true,
    perm: "daguan-microweb-module-open",
    moduleName: '视频微站'
  },
  path: '/microstation', // 跳转视频微站
  component: microstationIndex,
  children: [{
      path: '/microstation', // 默认跳转云导播
      redirect: '/microstation/list'
    },
    {
      path: '/microstation/new', // 跳转微站新建页面
      component: newStation
    },
    {
      path: '/microstation/built/:mwId', // 跳转微站编辑页面
      component: builtStation
    },
    {
      path: '/microstation/publish/:mwId', // 跳转微站发布页面
      component: publishStation
    },
    {
      path: '/microstation/list', // 跳转微站发布页面
      component: stationList
    }
  ]
}

// 电视直播
const tvliveIndex = resolve => require(['@/views/tvlive/index'], resolve);
const tvliveList = resolve => require(['@/views/tvlive/tvliveList'], resolve);
const programme = resolve => require(['@/views/tvlive/programme'], resolve);
const tvliveOperation = resolve => require(['@/views/tvlive/tvliveOperation'], resolve);
const tvliveCompilation = resolve => require(['@/views/tvlive/tvliveCompilation'], resolve);
//电视直播菜单
let tvLiveMenu = {
  meta: {
    auth: true,
    perm: "daguan-tvlive-module-open",
    moduleName: '电视直播'
  },
  path: '/tvlive', // 跳转电视直播
  component: tvliveIndex,
  children: [{
      path: '/tvlive', // 默认电视直播列表
      redirect: '/tvlive/list/1'
    },
    {
      path: '/tvlive/list/:channelType', // 跳转电视直播列表
      component: tvliveList
    },
    {
      path: '/tvlive/programme/:tvChannelId/:channelType', // 跳转节目单
      component: programme
    },
    {
      path: '/tvlive/operation/:activityId/:type', // 跳转频道运营
      component: tvliveOperation
    },
    {
      path: '/tvlive/compilation/:tvChannelId/:channelType', // 跳转电视合辑
      component: tvliveCompilation
    },
  ]
}

// AI智能
const AIIndex = resolve => require(['@/views/AI/index'], resolve);
const speechRecognition = resolve => require(['@/views/AI/speechRecognition'], resolve);
let aiMenu = {
  path: '/AI',
  component: AIIndex,
  children: [{
      path: '/AI', // 默认电视直播列表
      redirect: '/AI/speechRecognition'
    },
    {
      path: '/AI/speechRecognition', // 跳转电视直播列表
      component: speechRecognition
    },
  ]
}

// 赛事直播
const sportliveIndex = resolve => require(['@/views/sportlive/index'], resolve);
const sportliveList = resolve => require(['@/views/sportlive/sportliveList'], resolve);
const sportliveSchedule = resolve => require(['@/views/sportlive/schedule'], resolve);
const sportliveMonitorList = resolve => require(['@/views/live/flowmonitor/flowmonitorList'], resolve)
const sportliveMonitorEdit = resolve => require(['@/views/live/flowmonitor/flowmonitorEdit'], resolve)
const sportliveMonitorBigscreen = resolve => require(['@/views/live/flowmonitor/bigScreen'], resolve)

//赛事直播菜单
let sportliveMenu = {
  path: '/sportlive', // 跳转电视直播
  component: sportliveIndex,
  children: [{
      path: '/sportlive', // 默认电视直播列表
      redirect: '/sportlive/list'
    },
    {
      path: '/sportlive/list', // 跳转电视直播列表
      component: sportliveList
    },
    {
      path: '/sportlive/schedule/:sportId', // 跳转电视直播列表
      component: sportliveSchedule
    },
    {
      path: '/sportlive/flowmonitor/list/:programId', // 跳转电视直播列表
      component: sportliveMonitorList
    },
    {
      path: '/sportlive/flowmonitor/edit/:fid/:programId', // 跳转电视直播列表
      component: sportliveMonitorEdit
    },
    {
      path: '/sportlive/flowmonitor/bigScreen/:fid', // 跳转电视直播列表
      component: sportliveMonitorBigscreen
    },
  ]
}

const governance = resolve => require(['@/views/governance/governance.vue'], resolve)
const guideData = resolve => require(['@/views/governance/guideData.vue'], resolve)
const guideList = resolve => require(['@/views/governance/guideList.vue'], resolve)
const resource = resolve => require(['@/views/governance/resource.vue'], resolve)
let governance_v={
  meta: {
    auth: true,
    perm: "daguan-director-control-open",
    moduleName: '导播管控'
  },
  path:'/governance',    //导播管控
  component: governance,
  children:[{
      path: '/governance', // 默认跳转主页
      redirect: '/governance/guideData'
    },{
      path: '/governance/guideData', //
      component: guideData
    },{
      path: '/governance/guideList', //
      component: guideList
    },{
      path: '/governance/resource', //
      component: resource
    }
  ]
}

const allMenu = [liveMenu, vodMemu, productionMenu, microMenu, tvLiveMenu, aiMenu, sportliveMenu ,governance_v];

function getRoute4Menu(permissionArr) {
  let routeArr = [];
  if (permissionArr == null || permissionArr.length == 0) {
    return routeArr;
  }
  //寻找一级菜单
  for (let menu of allMenu) {
    if (menu.meta) {
      if (menu.meta.auth) {
        for (let permStr of permissionArr) {
          if (permStr == menu.meta.perm) {
            routeArr.push(menu);
          }
        }
      } else {
        routeArr.push(menu);
      }

    } else {
      routeArr.push(menu);
    }

  }

  //寻找二级菜单
  for (let menu of routeArr) {
    let childrenMenus = [];
    let childrens = menu.children;
    for (let childMenu of childrens) {
      if (childMenu.meta) {
        if (childMenu.meta.auth) { //如果需要做权限验证
          for (let permStr of permissionArr) {
            if (permStr == menu.meta.perm) {
              childrenMenus.push(childMenu);
              break;
            }
          }
        } else {
          childrenMenus.push(childMenu);
        }

      } else {
        childrenMenus.push(childMenu);
      }
    }
    menu.children = childrenMenus;
  }
  return routeArr;
}

export default getRoute4Menu;



// WEBPACK FOOTER //
// ./src/router/menu/daguanMenus.js